import React, { useState } from "react";
import { USE_LOCAL_FALLBACK } from "../../config/firebaseConfig";
import { db } from "../../services/firebase";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { getStudentPaymentSchedule } from "../../data/tuitionConfigs";
import { getStoredStudents, saveStoredStudents } from "../../services/studentsService";

export default function RecalculateTuition() {
  const [campus, setCampus] = useState("gapan");
  const [log, setLog] = useState("");
  const [busy, setBusy] = useState(false);

  function append(t) { setLog(l => (l ? l + "\n" : "") + t); }

  async function run() {
    setBusy(true);
    setLog("");
    try {
      if (USE_LOCAL_FALLBACK) {
        const list = getStoredStudents();
        let c = 0;
        const out = list.map(s => {
          if (String(s.campus || "").toLowerCase() !== campus) return s;
          const levelName = s.levelName || "";
          const mode = s.paymentMode || "Annual";
          if (!levelName) return s;
          const sched = getStudentPaymentSchedule({
            campus,
            levelName,
            paymentMode: mode,
            customDiscount: typeof s.customDiscountPercent === "number" ? s.customDiscountPercent / 100 : null
          });
        if (!sched) return s;
          c++;
          return { ...s, paymentSchedule: sched };
        });
        saveStoredStudents(out);
        append(`Recalculated ${c} student(s) locally.`);
      } else {
        const snap = await getDocs(collection(db, "students"));
        const docs = snap.docs.filter(d => String((d.data()?.campus || "")).toLowerCase() === campus);
        append(`Found ${docs.length} student(s).`);
        let c = 0;
        for (const d of docs) {
          const s = d.data() || {};
          const levelName = s.levelName || "";
          const mode = s.paymentMode || "Annual";
          if (!levelName) continue;
          const sched = getStudentPaymentSchedule({
            campus,
            levelName,
            paymentMode: mode,
            customDiscount: typeof s.customDiscountPercent === "number" ? s.customDiscountPercent / 100 : null
          });
          if (!sched) continue;
          await updateDoc(doc(db, "students", d.id), { paymentSchedule: sched });
          c++;
        }
        append(`Recalculated ${c} student(s) in Firestore.`);
      }
      append("Done.");
    } catch (e) {
      append(`Error: ${e.message || String(e)}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="container py-4">
      <h3 className="mb-3">Recalculate Tuition Schedules</h3>
      <div className="row g-2 mb-3">
        <div className="col-md-3">
          <label className="form-label">Campus</label>
          <select className="form-select" value={campus} onChange={e => setCampus(e.target.value)}>
            <option value="gapan">gapan</option>
            <option value="bulacan">bulacan</option>
          </select>
        </div>
      </div>
      <button className="btn btn-primary" onClick={run} disabled={busy}>Recalculate</button>
      <div className="card mt-3">
        <div className="card-body">
          <pre style={{ whiteSpace: "pre-wrap" }}>{log || "No logs yet"}</pre>
        </div>
      </div>
    </div>
  );
}
